import(/* webpackMode: "eager" */ "/test/components/site-header.tsx")